module.exports = __webpack_public_path__ + "img/github.54af2126.svg";